
import { NavLink,Link } from "react-router-dom";
import React, { useState } from "react";
import { FaSearch, FaPhoneAlt, FaCalendarAlt } from "react-icons/fa";
import { FiEdit } from "react-icons/fi";
import "../css/navbar.css";


  const Navbar = () => {

  const [search,setSearch]=useState("");
const [showSearch,setShowSearch]=useState(false);


const searchData=[
{
title:"Admission",
path:"/admission"
},
{
title:"Admission Process",
path:"/admission-process"
},
{
title:"School Levels",
path:"/school-levels"
},
{
title:"Primary School",
path:"/primary-school"
},
{
title:"Secondary School",
path:"/secondary-school"
},
{
title:"Higher Secondary",
path:"/high-school"
},
{
title:"Curriculum",
path:"/curriculum"
},
{
title:"Student Life",
path:"/student-life"
},
{
title:"Contact Us",
path:"/contact"
},
{
title:"Fee Structure",
path:"/feestructure"
}
];


const filteredSearch=searchData.filter((item)=>
item.title.toLowerCase()
.includes(search.toLowerCase())
);
   return (
    <nav className="navbar">
      {}
      <div className="nav-brand">
        <NavLink to="/">
          <img
            src={"/images/logo.png"}
            alt="LogoSahara "
            className="navbar-logo"
          />
        </NavLink>
        <span className="navbar-name">SAHARA PUBLIC SECONDARY SCHOOL</span>
      </div>

      {}
      <div className="nav-utilities">
        {}
   <div className="search-wrapper desktop-only">

<div className="search-bar">

<FaSearch className="search-icon"/>

<input
type="text"
placeholder="Search..."
value={search}
onFocus={()=>setShowSearch(true)}
onChange={(e)=>{
setSearch(e.target.value);
setShowSearch(true);
}}
/>

</div>


{
showSearch && search && (
<div className="search-result-box">

{
filteredSearch.length>0 ? (

filteredSearch.map((item,index)=>(

<Link
key={index}
to={item.path}
className="search-result-item"
onClick={()=>{
setSearch("");
setShowSearch(false);
}}
>

{item.title}

</Link>

))

):(


<div className="no-search-result">
No Result Found
</div>


)

}

</div>
)

}


</div>

        {}
        <div className="nav-item hide-mobile">
          <FiEdit className="icon admission-icon" />
          <span>
            <a href="/admission" className="nav-link">
              Online Admission
            </a>
          </span>
        </div>

        {}
        <div className="nav-item">
          <FaPhoneAlt className="icon contact-icon" />
          <span className="hide-mobile">
            <a href="/contact" className="nav-link">
              Contact Us
            </a>
          </span>
        </div>

        {}
   <button className="navbar-tour-btn">
  <FaCalendarAlt className="btn-icon" />
  <span className="btn-text">
    <NavLink to="/contact">
      Book a Tour
    </NavLink>
  </span>
</button>
      </div>
    </nav>
  );
};

export default Navbar;
